// extracted by mini-css-extract-plugin
module.exports = {"task-list":"task-list-00e622343bf3e44aec589284ffe998c5","list-item":"list-item-c61d8a19cb18ff310822607eb848c600"};